module.exports = __webpack_public_path__ + "static/img/2bg_17.d4f48e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_17.png
// module id = 666
// module chunks = 1